import { getDateColumn } from './DateColumn';
import { getDurationColumn } from './DurationColumn';
import { getLinkedWorkColumn } from './LinkedWorkColumn';
import { getMoneyColumn } from './MoneyColumn';
import { getProjectColumn } from './ProjectColumn';
import { getSelectionColumn } from './SelectionColumn';
import { getStateColumn } from './StateColumn';
import { getTagListColumn } from './TagListColumn';
import { getTagsColumn } from './TagsColumn';
import { getTextColumn } from './TextColumn';
import { getUserColumn } from './UserColumn';

const columnGetters = {
  user: getUserColumn,
  date: getDateColumn,
  money: getMoneyColumn,
  project: getProjectColumn,
  selection: getSelectionColumn,
  state: getStateColumn,
  tags: getTagsColumn,
  text: getTextColumn,
  duration: getDurationColumn,
  tagList: getTagListColumn,
  linkedWork: getLinkedWorkColumn,
} as const;

export default columnGetters;

export type ColumnGetters = typeof columnGetters;
export type ColumnType = keyof ColumnGetters;
export type ColumnParams<T extends ColumnType> = Parameters<ColumnGetters[T]>[1];
